import { limparTipos, nomesTipos } from "@/features/tipos-cliente";

import { TODOS_OS_MODULOS, modulosDoCupom, rotuloDosModulos, valeEmTodos } from "./modulos";

// Estado, resumo e gravação do formulário de cupom (refeito em 23/10/2026).

export const DIAS = [
  { v: 0, curto: "Dom", nome: "domingo" }, { v: 1, curto: "Seg", nome: "segunda" }, { v: 2, curto: "Ter", nome: "terça" },
  { v: 3, curto: "Qua", nome: "quarta" }, { v: 4, curto: "Qui", nome: "quinta" }, { v: 5, curto: "Sex", nome: "sexta" },
  { v: 6, curto: "Sáb", nome: "sábado" },
];

export const VAZIO = {
  code: "", description: "", discount_type: "percentage", discount_value: "", max_discount_value: "",
  min_order_value: "", usage_limit: "", usage_limit_per_customer: "1", valid_from: "", valid_until: "",
  time_from: "", time_until: "", valid_weekdays: [], is_active: true, first_order_only: false,
  visible_to_customer: true, is_club_coupon: false, applies_to_delivery: false, modules: [...TODOS_OS_MODULOS],
  segmentos: [], // para quem vale: tipos de cliente (27/10/2026); vazio = todos
};

const dia = (iso) => (iso ? String(iso).slice(0, 10) : "");
// Data do formulário: gravada só com o dia ("2023-01-01", cupom antigo) vale como
// está — `new Date` leria em UTC e mostraria o dia anterior no Brasil.
const diaLocal = (v) => {
  if (!v) return "";
  if (String(v).trim().length === 10) return String(v).trim();
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? dia(v) : d.toLocaleDateString("sv-SE");
};
const lista = (v) => {
  if (Array.isArray(v)) return v;
  try { return JSON.parse(v || "[]") || []; } catch { return []; }
};

/** Cupom gravado → formulário. */
export function doCupom(c) {
  if (!c) return { ...VAZIO };
  // Cupom antigo só com "até" (ou só "a partir de"): vira janela completa,
  // senão o formulário travaria o salvar pedindo o outro horário.
  const tf = c.time_from || (c.time_until ? "00:00" : "");
  const tu = c.time_until || (c.time_from ? "23:59" : "");
  return {
    ...VAZIO,
    code: c.code || "", description: c.description || "", discount_type: c.discount_type || "percentage",
    discount_value: c.discount_value ? String(c.discount_value) : "", max_discount_value: c.max_discount_value ? String(c.max_discount_value) : "",
    min_order_value: Number(c.min_order_value) > 0 ? String(c.min_order_value) : "",
    usage_limit: c.usage_limit ? String(c.usage_limit) : "", usage_limit_per_customer: c.usage_limit_per_customer ? String(c.usage_limit_per_customer) : "",
    // valid_until é gravado como 23:59:59 local em UTC: a data local é a certa
    valid_from: diaLocal(c.valid_from), valid_until: diaLocal(c.valid_until),
    time_from: tf, time_until: tu,
    valid_weekdays: lista(c.valid_weekdays).map(Number),
    is_active: c.is_active === 1 || c.is_active === true, first_order_only: !!c.first_order_only,
    visible_to_customer: c.visible_to_customer !== 0 && c.visible_to_customer !== false,
    is_club_coupon: !!c.is_club_coupon, applies_to_delivery: !!c.applies_to_delivery, modules: modulosDoCupom(c),
    segmentos: limparTipos(lista(c.segmentos)),
  };
}

const num = (v) => (v === "" || v == null ? null : Number(String(v).replace(",", ".")));

/** O que falta para gravar, ou null. */
export function erro(f, novo = true) {
  if (!f.code.trim()) return "Dê um código ao cupom";
  // Cupom antigo pode ter código fora do padrão: a trava vale só para cupom novo.
  if (novo && !/^[A-Z0-9_-]{3,30}$/.test(f.code.trim().toUpperCase())) return "O código usa só letras, números, - e _ (de 3 a 30)";
  if (f.discount_type !== "free_delivery" && !(num(f.discount_value) > 0)) return "Informe o valor do desconto";
  if (f.discount_type === "percentage" && num(f.discount_value) > 100) return "O desconto em % vai até 100";
  if (f.valid_from && f.valid_until && f.valid_from > f.valid_until) return "A data de início é depois da data de fim";
  if ((f.time_from && !f.time_until) || (!f.time_from && f.time_until)) return "Preencha o horário de início e de fim";
  if (f.time_from && f.time_from === f.time_until) return "O horário de início e o de fim são iguais. Para valer o dia todo, deixe sem horário";
  if (!f.modules.length) return "Marque pelo menos um lugar onde o cupom vale";
  return null;
}

/** Formulário → corpo do POST/PUT /coupons. */
export function payload(f) {
  const v = num(f.discount_value) || 0;
  return {
    code: f.code.toUpperCase().trim(), description: f.description.trim(), discount_type: f.discount_type,
    discount_value: f.discount_type === "free_delivery" ? 0 : v,
    max_discount_value: f.discount_type === "percentage" && num(f.max_discount_value) > 0 ? num(f.max_discount_value) : null,
    min_order_value: num(f.min_order_value) || 0,
    usage_limit: num(f.usage_limit) > 0 ? Math.round(num(f.usage_limit)) : null,
    usage_limit_per_customer: num(f.usage_limit_per_customer) > 0 ? Math.round(num(f.usage_limit_per_customer)) : null,
    // Datas no fuso do navegador: início às 00:00, fim às 23:59:59 do dia escolhido.
    valid_from: f.valid_from ? new Date(`${f.valid_from}T00:00:00`).toISOString() : null,
    valid_until: f.valid_until ? new Date(`${f.valid_until}T23:59:59`).toISOString() : null,
    time_from: f.time_from || null, time_until: f.time_until || null,
    valid_weekdays: f.valid_weekdays.length && f.valid_weekdays.length < 7 ? [...f.valid_weekdays].sort() : null,
    is_active: f.is_active, first_order_only: f.first_order_only, visible_to_customer: f.visible_to_customer,
    // Clube removido (27/10/2026): salvar limpa a marca dos cupons antigos
    is_club_coupon: false,
    applies_to_delivery: f.discount_type !== "free_delivery" && f.applies_to_delivery,
    modules: valeEmTodos(f.modules) ? null : f.modules,
    segmentos: limparTipos(f.segmentos),
  };
}

const reais = (v) => `R$ ${Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: Number(v) % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;
const dataBR = (d) => (d ? d.split("-").reverse().slice(0, 2).join("/") : "");

export const textos = {
  desconto(f) {
    if (f.discount_type === "free_delivery") return "Frete grátis";
    const v = num(f.discount_value) || 0;
    if (!v) return "—";
    return f.discount_type === "percentage"
      ? `${String(v).replace(".", ",")}% de desconto${num(f.max_discount_value) > 0 ? ` (até ${reais(f.max_discount_value)})` : ""}`
      : `${reais(v)} de desconto`;
  },
  minimo: (f) => (num(f.min_order_value) > 0 ? `Pedidos a partir de ${reais(f.min_order_value)}` : "Qualquer valor de pedido"),
  quem(f) {
    const partes = [];
    if (limparTipos(f.segmentos).length) partes.push(`Só para: ${nomesTipos(f.segmentos)}`);
    if (f.first_order_only) partes.push("Só no primeiro pedido do cliente");
    return partes.length ? partes.join(" · ") : "Qualquer cliente";
  },
  vezes(f) {
    const p = num(f.usage_limit_per_customer);
    const tot = num(f.usage_limit);
    return `${p > 0 ? `${p} ${p === 1 ? "vez" : "vezes"} por cliente` : "Sem limite por cliente"} · ${tot > 0 ? `${tot} usos no total` : "sem limite total"}`;
  },
  quando(f) {
    const partes = [];
    if (f.valid_from && f.valid_until) partes.push(`De ${dataBR(f.valid_from)} a ${dataBR(f.valid_until)}`);
    else if (f.valid_until) partes.push(`Até ${dataBR(f.valid_until)}`);
    else if (f.valid_from) partes.push(`A partir de ${dataBR(f.valid_from)}`);
    else partes.push("Sem data para acabar");
    const d = f.valid_weekdays;
    if (d.length && d.length < 7) partes.push(DIAS.filter((x) => d.includes(x.v)).map((x) => x.curto).join(", "));
    if (f.time_from && f.time_until) partes.push(`das ${f.time_from} às ${f.time_until}`);
    return partes.join(" · ");
  },
  onde: (f) => rotuloDosModulos(f.modules),
  cardapio: (f) => (f.visible_to_customer ? "Aparece na lista de cupons do cardápio" : "Só com o código (não aparece na lista)"),
};

/** A frase do rodapé: o cupom inteiro numa linha. */
export function resumo(f) {
  const d = textos.desconto(f);
  if (d === "—") return "Escolha o desconto para ver o resumo do cupom.";
  const minimo = num(f.min_order_value) > 0 ? ` em pedidos a partir de ${reais(f.min_order_value)}` : "";
  const para = limparTipos(f.segmentos).length ? ` Só para: ${nomesTipos(f.segmentos)}.` : "";
  return `${d}${minimo}, ${textos.vezes(f).split(" · ")[0].toLowerCase()}. ${textos.quando(f)}. Vale em: ${textos.onde(f)}.${para}`;
}

/** Sugestões de código pelo desconto. */
export function sugestoes(f) {
  const v = Math.round(num(f.discount_value) || 0);
  if (f.discount_type === "free_delivery") return ["FRETEGRATIS", "FRETE0", "ENTREGAGRATIS"];
  if (!v) return [];
  const base = f.discount_type === "percentage" ? `${v}` : `${v}REAIS`;
  return [`DESCONTO${base}`, `BEMVINDO${v}`, `VOLTA${v}`];
}
